export const EMAIL_LESSONS = [
  {
    id: 'email-1',
    numero: 1,
    titre: "Rédiger un email clair",
    sousTitre: "Structure et ton",
    contexte: "Vous devez écrire à la CAF pour demander des informations sur votre dossier. Comment rédiger un email efficace ?",
    explication: [
      "**L'objet** est la première chose que le destinataire voit. Soyez précis : 'Demande d'information — Dossier n°XXXXXXX' plutôt que 'Question'.",
      "**La structure** : Bonjour + votre demande claire + vos coordonnées + Cordialement. Pas besoin de faire long.",
      "**Votre numéro de dossier** : mentionnez-le toujours dans le corps du mail. Ça permet à l'agent de retrouver votre dossier immédiatement.",
      "**Le ton** : poli et factuel. Pas besoin de longues explications. 'Je me permets de vous contacter concernant...' fonctionne très bien.",
      "**Relisez avant d'envoyer** : vérifiez l'orthographe, l'adresse du destinataire et que vous avez bien joint les pièces si nécessaire.",
    ],
    question: "Quel objet d'email est le plus efficace pour contacter la CAF ?",
    options: [
      { id: 'a', text: "'Demande d'information — Dossier n°123456'", correct: true },
      { id: 'b', text: "'Question urgente'", correct: false },
      { id: 'c', text: "'Bonjour'", correct: false },
    ],
    explication_reponse: "Un objet précis avec votre numéro de dossier permet à l'agent de comprendre immédiatement de quoi il s'agit et de retrouver votre dossier sans chercher. 'Question urgente' ou 'Bonjour' n'apportent aucune information utile.",
  },
  {
    id: 'email-2',
    numero: 2,
    titre: "Joindre un fichier",
    sousTitre: "Le trombone 📎",
    contexte: "Vous devez envoyer des justificatifs par email. Comment joindre un fichier correctement ?",
    explication: [
      "**Le bouton pièce jointe** ressemble à un trombone 📎. Il se trouve généralement en bas ou en haut de la fenêtre de composition.",
      "**Sur PC** : cliquez sur le trombone, une fenêtre s'ouvre pour naviguer dans vos fichiers. Sélectionnez le document et cliquez 'Ouvrir'.",
      "**Sur téléphone** : appuyez sur le trombone ou 'Joindre', puis choisissez 'Fichiers' ou 'Photos' selon ce que vous voulez envoyer.",
      "**Vérifiez que le fichier est bien joint** : son nom doit apparaître sous votre message avant d'envoyer.",
      "**Formats acceptés** : PDF, JPG, PNG. Évitez les formats rares comme HEIC (photos iPhone) — convertissez-les en JPG d'abord.",
    ],
    question: "Vous avez joint un fichier. Comment vérifier qu'il est bien attaché avant d'envoyer ?",
    options: [
      { id: 'a', text: "Son nom apparaît sous le message dans la fenêtre de composition", correct: true },
      { id: 'b', text: "Un message de confirmation apparaît automatiquement", correct: false },
      { id: 'c', text: "Il faut envoyer et attendre la réponse pour le savoir", correct: false },
    ],
    explication_reponse: "Avant d'envoyer, le nom du fichier joint apparaît toujours dans la fenêtre de composition — c'est la seule vérification fiable. Prenez l'habitude de vérifier avant chaque envoi.",
  },
  {
    id: 'email-3',
    numero: 3,
    titre: "Reconnaître un email frauduleux",
    sousTitre: "Le phishing",
    contexte: "Vous recevez un email de 'votre banque' qui vous demande de cliquer sur un lien urgent. Est-ce vraiment votre banque ?",
    explication: [
      "**Le phishing** est une arnaque où des escrocs se font passer pour des organismes officiels (banque, CAF, impôts) pour voler vos informations.",
      "**Les signes d'alerte** : fautes d'orthographe, adresse email bizarre (exemple : caf-france@gmail.com au lieu de @caf.fr), ton très urgent ('Votre compte sera bloqué dans 24h').",
      "**Ne cliquez jamais sur un lien suspect** — allez directement sur le site officiel en tapant l'adresse dans votre navigateur.",
      "**Les vrais organismes** (banque, CAF, impôts) ne demandent JAMAIS votre mot de passe par email.",
      "**En cas de doute** : appelez directement l'organisme avec le numéro officiel trouvé sur leur site web — pas le numéro indiqué dans l'email suspect.",
    ],
    question: "Vous recevez un email de 'caf-alertes@gmail.com' disant que votre dossier est suspendu. Que faire ?",
    options: [
      { id: 'a', text: "Ne pas cliquer, aller directement sur le site officiel caf.fr", correct: true },
      { id: 'b', text: "Cliquer sur le lien pour vérifier votre dossier", correct: false },
      { id: 'c', text: "Répondre pour demander des précisions", correct: false },
    ],
    explication_reponse: "L'adresse '@gmail.com' est un signal d'alarme immédiat — la vraie CAF utilise '@caf.fr'. Ne cliquez jamais sur ces liens. Allez directement sur caf.fr en tapant l'adresse dans votre navigateur pour vérifier votre dossier.",
  },
  {
    id: 'email-4',
    numero: 4,
    titre: "Organiser sa boîte mail",
    sousTitre: "Ne plus rien rater",
    contexte: "Votre boîte mail est pleine, vous ratez des emails importants. Comment s'organiser ?",
    explication: [
      "**Créez des dossiers** par thème : CAF, CPAM, Impôts, Banque, Famille. Déplacez les emails importants dedans après lecture.",
      "**Les étoiles et drapeaux** permettent de marquer les emails qui nécessitent une action. Utilisez-les pour les courriers avec délai.",
      "**Désabonnez-vous** des newsletters que vous ne lisez pas : cherchez le lien 'Se désabonner' en bas de l'email. Ça nettoie rapidement.",
      "**Videz régulièrement** votre corbeille et vos spams — une boîte trop pleine peut bloquer la réception de nouveaux emails.",
      "**Archivez plutôt que supprimer** les emails importants — ils restent accessibles en cas de besoin mais n'encombrent plus votre boîte principale.",
    ],
    question: "Vous recevez un email CAF avec un délai de 15 jours. Quelle est la meilleure action ?",
    options: [
      { id: 'a', text: "Le marquer avec un drapeau et noter la date limite dans votre calendrier", correct: true },
      { id: 'b', text: "Le supprimer après lecture pour ne pas encombrer la boîte", correct: false },
      { id: 'c', text: "Le laisser comme non-lu pour ne pas l'oublier", correct: false },
    ],
    explication_reponse: "Marquer + noter dans le calendrier, c'est la méthode la plus sûre. Laisser non-lu ne fonctionne pas quand on a beaucoup d'emails. Supprimer est dangereux — vous perdez la preuve et les informations du dossier.",
  },
];
